module.exports = __webpack_public_path__ + "img/menuboard_teryiaki_large.f8c43441.png";